import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp, increment, setDoc, doc, getDoc } from "firebase/firestore";
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet";
import About from "./About";
import omorelogo from "../Images/omorelogo.png";
import dualis from "../Images/dualisimg.png"
import synchro from "../Images/synchroimg.png"
import axion from "../Images/axionimg.png"
import neuralis from "../Images/neuralisimg.png"
import { getUserId } from "../utils/userId";

import {getRandomName} from "../utils/Randomname"
import {getLocation} from "../utils/getLocation"
import {getUserName} from "../utils/getUserName"



const GAMES_DATA = [
  {
    id: "GAME-01",
    title: "NEURALIS",
    category: "Protocol: Reflex",
    description: "Neural synchronization test. Optimize your reaction latency.",
    status: "Active",
    path: "/neuralis",
    active: true,
    feature: "Speed",
    bgImage: neuralis,
    videoUrl: "https://res.cloudinary.com/dwhmf5ax8/image/upload/v1773476086/A_hightech_3d_neural_network_on_a_deep_black-ezgif.com-crop_atyhuw.mp4", // Add your AI-generated video path here
    textColor: "text-blue-500",
    borderAccent: "border-blue-500/40"
  },
  {
    id: "GAME-02",
    title: "AXION",
    category: "Protocol: Target",
    description: "Precision accuracy sweep. Calibrate your target acquisition.",
    status: "Active",
    path: "/axion",
    active: false,
    feature: "Aim",
    bgImage: axion,
    videoUrl: "https://res.cloudinary.com/dwhmf5ax8/image/upload/v1773476079/Futuristic_red_hud_interface_with_scanning_la-ezgif.com-crop_rzcjv6.mp4",
    textColor: "text-red-500",
    borderAccent: "border-red-500/40"
  },
  {
    id: "GAME-03",
    title: "SYNCHRO",
    category: "Protocol: Beat",
    description: "Rhythmic wave matching. Maintain temporal alignment.",
    status: "Locked",
    path: "/synchro-intro",
    active: false, // Set to false if it's just "Planned"
    feature: "Sync",
    bgImage: synchro,
    videoUrl: "https://res.cloudinary.com/dwhmf5ax8/image/upload/v1773476064/Abstract_purple_neon_fluid_waves_moving_like-ezgif.com-crop_didfp4.mp4",
    textColor: "text-purple-500",
    borderAccent: "border-purple-500/40"
  },
  {
    id: "GAME-04",
    title: "DUALIS",
    category: "Protocol: Double",
    description: "Concurrent data processing. Split-focus multi-tasking.",
    status: "Locked",
    path: "/dualis-intro",
    active: false,
    feature: "Dual",
    bgImage: dualis,
    videoUrl: "https://res.cloudinary.com/dwhmf5ax8/image/upload/v1773475516/_two_symmetrical_goldenyellow_energy_cores-ezgif.com-crop_si4cuu.mp4",
    textColor: "text-yellow-400",
    borderAccent: "border-yellow-400/40"
  },
  
];

export default function GamesHub() {
  const navigate = useNavigate();
  const [isFullscreen, setIsFullscreen] = useState(true);
  const [isPressing, setIsPressing] = useState(false);
  const [isLoading, setIsLoading] = useState(() => !sessionStorage.getItem("hasLoaded_hub"));
  const [ratingGame, setRatingGame] = useState(null); // Stores the game object
  const timerRef = useRef(null);
  const HOLD_DURATION = 800;

  const [selectedGame, setSelectedGame] = useState(null);

  const [showPlayWarning, setShowPlayWarning] = useState(false);

// Update your card click handler to toggle playback instead of navigating immediately
const handleCardInteraction = (game) => {
  // If the card is already selected and it's active, navigate on the second tap
  if (selectedGame === game.id && game.active) {
    navigate(game.path);
    return;
  }

  // If it's the first tap (or it's inactive), just select it to show the video/UI
  setSelectedGame(game.id);
};

  useEffect(() => {
    if (isLoading && isFullscreen) {
      const loadTimer = setTimeout(() => {
        setIsLoading(false);
        sessionStorage.setItem("hasLoaded_hub", "true");
      }, 2500);
      return () => clearTimeout(loadTimer);
    }
  }, [isLoading, isFullscreen]);

  const handlePressStart = (e) => {
    if (e.type === 'touchstart') e.preventDefault();
    setIsPressing(true);
    timerRef.current = setTimeout(() => {
      setIsFullscreen((prev) => !prev);
      setIsPressing(false);
      if (!isFullscreen) setIsLoading(true);
    }, HOLD_DURATION);
  };

  const handlePressEnd = () => {
    setIsPressing(false);
    if (timerRef.current) clearTimeout(timerRef.current);
  };

const getUserId = () => {
  let id = localStorage.getItem("omore_user_id");

  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("omore_user_id", id);
  }

  return id;
};


const saveRating = async (game, value, label) => {
  try {

    const userId = localStorage.getItem("omore_user_id");

    if (!userId) {
      alert("Play game first");
      return;
    }

    const gameId =
      game.id ||
      game.title.toLowerCase().replace(/\s+/g, "_");

    const ref = doc(
      db,
      "game_sessions",
      userId,
      "sessions",
      gameId
    );

    const snap = await getDoc(ref);

    // ❌ no session → don't allow rating
    if (!snap.exists()) {
      alert("Play the game first, then rate");
      return;
    }

    // ✅ update rating
    await setDoc(
      ref,
      {
        rating: value,
        ratingLabel: label,
        lastRatedAt: serverTimestamp(),
      },
      { merge: true }
    );

    console.log("Rating saved");

  } catch (e) {
    console.error("Error saving rating", e);
  }
};





  return (
    <>
      <Helmet>
        <title>OMORE Games | Select Game</title>
      </Helmet>

      {/* Changed overflow-y-auto to overflow-hidden */}
      <div className={isFullscreen 
        ? "fixed inset-0 z-50 bg-[#0a0a0b] overflow-hidden flex flex-col select-none" 
        : "relative w-full bg-transparent"
      }>
        
        {/* --- LOADER --- */}
                {/* --- TIER 0: CINEMATIC STUDIO LOADER --- */}
{isFullscreen && isLoading && (
  <div className="fixed inset-0 z-[200] bg-[#050506] flex flex-col items-center justify-center overflow-hidden">
    
    {/* 1. BACKGROUND EFFECTS */}
    {/* Grid Layer */}
    <div className="absolute inset-0 opacity-[0.03] pointer-events-none" 
      style={{ 
        backgroundImage: 'linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)', 
        backgroundSize: 'clamp(40px, 5vw, 80px) clamp(40px, 5vw, 80px)' 
      }} 
    />
    
    {/* Subtle Vignette for depth */}
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,#000_100%)] opacity-60" />

    {/* 2. CENTRAL INITIALIZATION CONTENT */}
    <div className="relative flex flex-col items-center px-6 text-center animate-in fade-in zoom-in-95 duration-1000">
      
      {/* ADAPTIVE LOGO */}
      <div className="relative mb-8 md:mb-16 group">
        <img
          src={omorelogo}
          alt="OMORE"
          className="h-14 md:h-24 w-auto brightness-125 z-10 relative drop-shadow-[0_0_30px_rgba(59,130,246,0.3)] transition-transform duration-500 group-hover:scale-105"
        />
        {/* Dual Pulse Rings */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-24 h-24 md:w-40 md:h-40 border border-blue-500/20 rounded-full animate-ping opacity-20" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-32 h-32 md:w-48 md:h-48 border border-blue-500/10 rounded-full animate-pulse" />
      </div>

      {/* CONNECTION SEQUENCE */}
      <div className="flex flex-col items-center max-w-xs md:max-w-md w-full">
        <div className="flex flex-col items-center w-full space-y-6">
          <div className="space-y-1">
            <span className="text-[8px] md:text-[11px] text-blue-500 font-mono tracking-[0.6em] md:tracking-[1em] uppercase block leading-none">
              Establishing Connection
            </span>
           
          </div>
          
          {/* Adaptive Loading Nodes */}
          <div className="flex gap-2 md:gap-3 w-full justify-center">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="flex-1 max-w-[60px] h-[2px] md:h-[3px] bg-zinc-900 overflow-hidden rounded-full relative">
                <div 
                  className="absolute inset-0 bg-gradient-to-r from-transparent via-blue-500 to-transparent shadow-[0_0_12px_#3b82f6] animate-[nodePulse_2s_ease-in-out_infinite]" 
                  style={{ animationDelay: `${i * 0.15}s` }} 
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>

    {/* 3. BRANDING FOOTER */}
    <div className="absolute bottom-8 md:bottom-12 w-full flex flex-col items-center animate-in slide-in-from-bottom-4 duration-1000 delay-300">
         <div className="flex flex-col items-center space-y-3">
           <span className="text-[9px] md:text-[12px] tracking-[1em] md:tracking-[1.5em] text-white/30 uppercase font-black -mr-[1em] md:-mr-[1.5em]">
             OMORE.GAMES
           </span>
           <div className="h-[1px] w-12 md:w-20 bg-gradient-to-r from-transparent via-zinc-800 to-transparent" />
         </div>
    </div>

    {/* CSS ANIMATIONS */}
    <style dangerouslySetInnerHTML={{ __html: `
      @keyframes nodePulse {
        0% { transform: translateX(-120%); }
        50% { transform: translateX(120%); }
        100% { transform: translateX(-120%); }
      }
    `}} />
  </div>
)}


<div className={`relative flex flex-col items-center w-full h-full max-w-7xl mx-auto px-4 transition-opacity duration-1000 ${isLoading && isFullscreen ? "opacity-0" : "opacity-100"}`}>
  
  {/* HEADER SECTION */}
  <div className="w-full flex flex-col items-center py-6 md:py-10 shrink-0">
    <img src={omorelogo} alt="Logo" className="h-8 md:h-10 w-auto mb-2" />
    <h1 className="text-2xl md:text-5xl font-black tracking-tighter text-white uppercase italic">Select Game</h1>
    <div className="h-[1px] w-12 bg-blue-500 mt-2" />
  </div>

  {/* GAMES GRID - Colors are now permanent, not hover-based */}
{/* GAMES GRID */}
<div className="
  /* Mobile: Horizontal scroll with momentum */
  flex overflow-x-auto lg:overflow-visible 
  /* Tablet/Desktop: Grid layout */
  lg:grid lg:grid-cols-4 
  /* Spacing & Behavior */
  gap-4 md:gap-6 w-full flex-grow mb-6 pb-6 lg:pb-0 
  snap-x snap-mandatory scrollbar-hide
">
  {GAMES_DATA.map((game) => (
    <div 
      key={game.id}
      onClick={() => handleCardInteraction(game)}
      className={`
        /* Dynamic Width: 85% on small phones, 45% on tablets, auto on desktop */
        min-w-[85%] sm:min-w-[45%] lg:min-w-0 
        snap-center flex-shrink-0
        group relative rounded-2xl overflow-hidden border transition-all duration-500 bg-zinc-950
        ${game.borderAccent} 
        ${selectedGame === game.id ? 'ring-2 ring-white/20 scale-[1] shadow-2xl' : 'hover:border-white/30 cursor-pointer'}
      `}
    >
      {/* 1. BACKGROUND VIDEO */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        <video
          key={game.videoUrl}
          src={game.videoUrl}
          poster={game.bgImage}
          loop
          muted
          playsInline
          preload="auto"
          className={`w-full h-full object-cover transition-all duration-1000
            ${selectedGame === game.id ? 'opacity-90 scale-110' : 'opacity-40 scale-100'}
          `}
          ref={(el) => {
            if (el) {
              selectedGame === game.id ? el.play().catch(() => {}) : el.pause();
            }
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-black/40" />
      </div>

      {/* 2. CONTENT LAYER */}
      <div className="relative z-10 h-full p-4 md:p-6 flex flex-col justify-between pointer-events-none">
        
        {/* Header (Title/Category) */}
        <div className={`transition-all duration-700 ${selectedGame === game.id ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-90'}`}>
          <div className="flex items-center gap-2 mb-1">
             <div className={`w-1.5 h-1.5 rounded-full ${game.textColor.replace('text-', 'bg-')}`} />
             <span className="text-[8px] md:text-[10px] font-bold tracking-[0.3em] text-white/50 uppercase">
               {game.category}
             </span>
          </div>
          <h3 className={`text-xl md:text-3xl xl:text-4xl font-black tracking-tighter italic uppercase drop-shadow-md ${game.textColor}`}>
            {game.title}
          </h3>
        </div>

        {/* Footer (Actions/Rating) */}
        <div className="space-y-3 md:space-y-4">
          <div className={`transition-all duration-500 transform ${
            selectedGame === game.id ? 'translate-y-0 opacity-100' : 'translate-y-6 opacity-0 pointer-events-none'
          }`}>
            {game.active ? (
              <Link
                to={game.path} 
onClick={async (e) => {

  e.preventDefault();
  e.stopPropagation();

  try {

    const userId = getUserId();
    const userName = getUserName();
    const location = await getLocation();

    const gameId = game.id; // important

    await setDoc(
      doc(
        db,
        "game_sessions",
        userId,
        "sessions",
        gameId   // ✅ doc id = game id
      ),
      {
        game: game.id,
        title: game.title,

        userId,
        userName,

        country: location.country || null,
        city: location.city || null,
        region: location.region || null,

        userAgent: navigator.userAgent,
        platform: navigator.platform,

        width: window.innerWidth,
        height: window.innerHeight,

        lastVisit: serverTimestamp(), // ✅ update every time

        enterCount: increment(1) // optional counter

      },
      { merge: true } // ✅ update instead of replace
    );

  } catch (err) {
    console.log(err);
  }

  navigate(game.path);

}}
     className="pointer-events-auto block group/btn relative overflow-hidden rounded-lg"
              >
                <div className={`absolute inset-0 opacity-20 group-hover/btn:opacity-40 transition-opacity ${game.textColor.replace('text-', 'bg-')}`} />
                <div className="relative flex items-center justify-center gap-2 py-2.5 md:py-3 px-4 bg-white/10 backdrop-blur-xl border border-white/20 group-hover/btn:border-white/50 transition-all">
                  <span className="text-[10px] md:text-xs font-black text-white tracking-[0.3em] uppercase italic">Play</span>
                  <svg className="w-3 h-3 md:w-4 md:h-4 text-white group-hover/btn:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </div>
              </Link>
            ) : (
              <div className="pointer-events-auto block relative overflow-hidden rounded-lg">
                <div className="relative flex items-center justify-center py-2.5 md:py-3 px-4 bg-zinc-900/60 backdrop-blur-md border border-white/5">
                  <span className="text-[9px] md:text-[11px] font-black text-zinc-600 tracking-[0.2em] uppercase italic">Launching Soon</span>
                </div>
              </div>
            )}
          </div>

          {/* Rating & Feature Bar */}
          <div className={`flex flex-col sm:flex-row sm:items-center justify-between gap-2 p-2 md:p-3 rounded-xl bg-black/60 backdrop-blur-md border border-white/5 transition-all duration-500 ${
            selectedGame === game.id ? 'border-white/20 bg-black/80' : ''
          }`}>
            <div className="flex flex-col">
              <span className="text-[6px] md:text-[7px] text-white/30 font-bold uppercase tracking-widest">Protocol</span>
              <span className="text-[9px] md:text-xs uppercase font-black text-white tracking-tighter truncate max-w-[100px] sm:max-w-none">
                {game.feature}
              </span>
            </div>
            
           <button 
  type="button" // Explicitly define type
onClick={(e) => {

  e.preventDefault();
  e.stopPropagation();

  const userId = localStorage.getItem("omore_user_id");

  // user never played
  if (!userId) {
    setShowPlayWarning(true);
    return;
  }

  // open rating popup
  setRatingGame(game);

}}
  /* Added z-40 and relative to ensure it sits above the 
     pointer-events-none parent layer 
  */
  className="pointer-events-auto relative z-40 group/rate flex items-center justify-between sm:justify-start gap-2 bg-white/5 hover:bg-white/10 px-2.5 py-1.5 rounded-lg transition-all border border-white/5 active:scale-90"
>
  <span className="text-[7px] md:text-[9px] font-black text-zinc-400 group-hover/rate:text-yellow-500 uppercase whitespace-nowrap">
    Difficulty
  </span>
  <div className="flex gap-0.5">
    {[...Array(3)].map((_, i) => (
      <div 
        key={i} 
        className="w-1 h-1 bg-yellow-600/40 group-hover/rate:bg-yellow-500 rounded-full transition-colors" 
      />
    ))}
  </div>
</button>
          </div>
        </div>
      </div>
    </div>
  ))}
</div>

{showPlayWarning && (
  <div className="fixed inset-0 z-[1100] flex items-center justify-center bg-black/80">

    <div className="bg-zinc-900 border border-white/10 p-6 rounded-xl">

      <p className="text-white text-sm mb-4">
        Play the game first, then rate it.
      </p>

      <button
        onClick={() => setShowPlayWarning(false)}
        className="px-4 py-2 bg-white text-black text-xs font-bold"
      >
        OK
      </button>

    </div>

  </div>
)}

{/* 3. RATING POPUP OVERLAY */}
{ratingGame && (
  <div className="fixed inset-0 z-[1000] flex items-center justify-center p-4 md:p-6">
    {/* Backdrop with blur */}
    <div 
      className="absolute inset-0 bg-black/90 backdrop-blur-md animate-in fade-in duration-300"
      onClick={() => setRatingGame(null)} 
    />
    
    {/* Modal Content */}
    <div className="relative z-10 bg-zinc-950 border border-white/10 p-6 md:p-8 rounded-2xl max-w-md w-full shadow-[0_0_50px_rgba(0,0,0,1)] animate-in zoom-in-95 slide-in-from-bottom-4 duration-300">
      
      {/* Header */}
      <div className="mb-6">
        <h4 className="text-zinc-500 text-[10px] font-black uppercase tracking-[0.3em] mb-1">
          Feedback System
        </h4>
        <h2 className={`text-2xl md:text-3xl font-black italic uppercase tracking-tighter ${ratingGame.textColor}`}>
          {ratingGame.title}
        </h2>
      </div>
      
      <p className="text-zinc-400 text-xs md:text-sm mb-8 font-medium leading-relaxed">
        How would you rate the difficulty level of this Game? Your feedback helps synchronize the system.
      </p>
      
      {/* Rating Buttons with Labels */}
      <div className="grid grid-cols-5 gap-2 mb-10">
        {[
          { val: 1, label: 'Easy' },
          { val: 2, label: 'Fair' },
          { val: 3, label: 'Mid' },
          { val: 4, label: 'Hard' },
          { val: 5, label: 'Elite' }
        ].map((item) => (
          <button 
            key={item.val}
          onClick={async () => {

  await saveRating(
    ratingGame,
    item.val,
    item.label
  );

  setRatingGame(null);

}}
            className="group flex flex-col items-center gap-2"
          >
            <div className="w-full aspect-square rounded-xl border border-white/10 bg-white/5 group-hover:border-yellow-500/50 group-hover:bg-yellow-500/10 text-white font-black transition-all flex items-center justify-center text-lg active:scale-90">
              {item.val}
            </div>
            <span className="text-[10px] md:text-[12px] font-black uppercase tracking-tighter text-zinc-500 group-hover:text-yellow-500 transition-colors">
              {item.label}
            </span>
          </button>
        ))}
      </div>
      
      {/* Cancel Button */}
      <button 
        onClick={() => setRatingGame(null)}
        className="w-full py-3 text-[10px] font-black text-zinc-600 uppercase tracking-[0.4em] hover:text-white transition-colors"
      >
        Abort Connection
      </button>
    </div>
  </div>
)}

  {/* FOOTER BUTTON */}
  <div className="pb-8 md:pb-12 shrink-0">
     <button
        onMouseDown={handlePressStart} onMouseUp={handlePressEnd}
        onTouchStart={handlePressStart} onTouchEnd={handlePressEnd}
        className="group relative px-8 py-4 md:px-12 md:py-5 border border-white/10 bg-white/5 backdrop-blur-sm overflow-hidden"
      >
        <span className="relative z-10 text-[8px] md:text-[10px] tracking-[0.3em] uppercase font-bold text-zinc-500">
          {isPressing ? "Processing..." : isFullscreen ? "Hold to Exit Hub" : "Hold for Fullscreen"}
        </span>
        <div className="absolute bottom-0 left-0 w-full h-[2px] bg-white/5">
          <div 
            className="h-full bg-blue-600 shadow-[0_0_10px_#2563eb] transition-all ease-linear"
            style={{ width: isPressing ? "100%" : "0%", transitionDuration: isPressing ? `${HOLD_DURATION}ms` : "150ms" }}
          />
        </div>
      </button>
  </div>
</div>
      </div>
      {!isFullscreen && <About />}
    </>
  );
}